import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getAbout } from "../../../lib/Services_with_Query";
import Loader from "../../../Component/Loader/Loader";

const Feature = ({ website_id, agent_id }) => {
  const shouldFetch = website_id && agent_id ? true : false;
  const { data, isLoading, error } = useQuery({
    queryFn: () => getAbout(website_id, agent_id),
    enabled: shouldFetch,
  });

  if (isLoading) return <Loader />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      {/* Start Feature Area */}
      <div className="feature-area fix area-padding">
        <div className="container">
          <div className="row d-flex align-items-center">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="feature-content">
                <div className="feature-images">
                  {!data ? (
                    <img
                      src="/assets/img/feature/vd.jpg"
                      alt=""
                      className="first-img"
                    />
                  ) : (
                    <img src={data?.image} alt="" className="first-img" />
                  )}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="feature-all">
                <div className="left-headline">
                  <p className="top-head" style={{ fontSize: "50px" }}>
                    About us
                  </p>
                  {!data && (
                    <>
                      <h2> Revolutionizing Business Travel +</h2>
                      <p>
                        Travel + is an innovative digital platform designed to
                        revolutionize business Travel + by enhancing
                        communication between businesses and expert consultants.
                      </p>
                    </>
                  )}

                  <div dangerouslySetInnerHTML={{ __html: data?.content }} />
                </div>
                {/* about single */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Feature Area */}
    </>
  );
};

export default Feature;
